import React from 'react'
import * as d3 from 'd3'
import { formatValue } from 'state/utils'

class RetirementChart extends React.Component {

  constructor(props) {
    super(props)

    this.chartRef = null
    // this.tooltipRef = null

    this.chartRefHeight = null
    this.chartRefWidth = null

    this.height = null
    this.width = null
    
    this.xScale = null
    this.yScale = null

    this.yAnnualIncomeScale = null

    this.renderChart = this.renderChart.bind(this)
    this.renderRetirementLabel = this.renderRetirementLabel.bind(this)
    this.renderAxisLine = this.renderAxisLine.bind(this)
    this.renderAnnualIncomeDistribution = this.renderAnnualIncomeDistribution.bind(this)
    this.renderTooltip = this.renderTooltip.bind(this)
    this.onMouseEnter = this.onMouseEnter.bind(this)

    
  }

  

  renderRetirementLabel(svg) {

    const marker = this.props.chartData.filter(d => d.age === parseInt(this.props.retirementAge))[0]

    const markerText = svg.append('text')
      .attr('class', 'MarkerLabel')
      .text(`${marker.age} years old`)

    const markerTextDimensions = markerText.node().getBBox()
    // console.warn(markerTextDimensions)
    // SVGRect {x: 290.90625, y: 54.6875, width: 87.15625, height: 18.5}

    markerText
      .attr('x', this.xScale(marker.age) + 10)
      .attr('y', this.yScale(marker.totalWealth) - 10)

    

      
  }

  renderAxisLine(svg) {

    // const props.retirementAge = 56
    
    const marker = this.props.chartData.filter(d => d.age === parseInt(this.props.retirementAge))[0]
    console.warn(marker, this.props.chartData, this.props.retirementAge)
    svg.append("line")
      .attr('class', 'axis_line axis_line--retirement')
      .attr('x1', this.xScale(marker.age))
      .attr('x2', this.xScale(marker.age))
      .attr('y1', 0)
      .attr('y2', this.height)
  }


  renderAnnualIncomeDistribution(svg) {
    console.warn('height', this.height)
    svg.selectAll('rect').data(this.props.chartData)      
    .enter()
    .filter(d => {
      return d.netDistributionReal !== null
    })
    .append('rect')
  
    .attr('width', d => (this.width / this.props.chartData.length) - 2)
    .attr('height', d => this.height - this.yAnnualIncomeScale(Math.abs(d.netDistributionReal)))
    .attr('x', d => this.xScale(d.age) - (this.width / this.props.chartData.length))
    .attr('y', d => this.yAnnualIncomeScale(Math.abs(d.netDistributionReal)))
    .attr('class', 'AnnualIncomeDistribution')

  }
  renderTooltip(svg, margin) {

    const tooltip = d3.select('.RetirementChart').append('div')
      .attr('class', 'ChartTooltip')
      .attr('style', 'transform: translate(0,0); opacity: 0;')

    svg.append("rect")
      .attr("width", this.width)
      .attr("height", this.height)
      .style("fill", "none")
      .style("pointer-events", "all")
      .on("mousemove", onMouseMove)
      .on('mouseenter', () => {
        tooltip.node().style.opacity = 1
      })
      .on('mouseleave', () => {
        tooltip.node().style.opacity = 0
      });


    // const tooltipRef = this.tooltipRef
    const data = this.props.chartData
    const width = this.width
    const xScale = this.xScale
    const yScale = this.yScale


    
    const bisectAge = d3.bisector(d => d.age).left

    function getPosition(rowIndex) {
      // Height may change so we need to check on each event
      const tooltipDimensions = tooltip.node().getBoundingClientRect()
  
      let x = xScale(data[rowIndex].age) + margin.left - (tooltipDimensions.width/2)
      const y = yScale(data[rowIndex].totalWealth) - tooltipDimensions.height - 10

      return `transform: translate(${Math.round(x)}px, ${Math.round(y)}px)`
    }

    function renderTooltipLabel(data) {
      let label = `
        <p class="ChartTooltip__label__heading">Age</p>
        <p class="ChartTooltip__label__value">${data.age} years old</p>
        <p class="ChartTooltip__label__heading">Total Wealth</p>
        <p class="ChartTooltip__label__value">${formatValue(data.totalWealth)}</p>
      `

      if (data.netDistributionReal) {
        label += `
          <p class="ChartTooltip__label__heading">Net Distribution</p>
          <p class="ChartTooltip__label__value">${formatValue(Math.abs(data.netDistributionReal))}</p>
        `
      }

      return label
    }

    function onMouseMove() {
      const rowIndex = Math.min(bisectAge(data, xScale.invert(d3.mouse(this)[0])), data.length - 1)
      tooltip.attr('style', getPosition(rowIndex))
      tooltip.html(renderTooltipLabel(data[rowIndex]))
    }

  }


  componentDidUpdate(prevProps) {
    if (prevProps.data !== this.props.chartData && this.props.chartData.length > 0)
      this.renderChart()
  }

  renderChart() {

    d3.select('.ChartTooltip').remove()
    d3.select(this.chartRef).select("svg").remove()
    

    var margin = {
      top: 0,
      right: 50,
      bottom: 30,
      left: 50
    }

    

    let data = this.props.chartData
    // const chart = CreateChartRenderer(this.chartRef, data)

    const dimensions = this.chartRef.getBoundingClientRect()
    this.width = dimensions.width - margin.left - margin.right
    this.height = dimensions.height - margin.top - margin.bottom

    this.xScale = d3.scaleLinear().range([0, this.width]);
    this.yScale = d3.scaleLinear().range([this.height, 0]);
    this.yAnnualIncomeScale = d3.scaleLinear().range([this.height, 0]);




    const svg = d3.select(this.chartRef).append("svg")
      .attr("width", this.width + margin.left + margin.right)
      .attr("height", this.height + margin.top + margin.bottom)
      .append("g")
      .attr("transform", `translate(${margin.left}, ${margin.top})`)
        


    // const { width, height } = this.chartRef.getBoundingClientRect()

    // Array of data to be rendered
    

    // Set the ranges
    // This creates linear scale from values into below dimensions
    // Without this a data point of 4000 would be 4000px large
    // var x = d3.scaleLinear().range([0, width]);
    // var y = d3.scaleLinear().range([height, 0]);

    // Scale the range of the data
    this.xScale.domain(d3.extent(data, function(d) { return d.age; }));
    
    const max = d3.max(data, function(d) { return d.totalWealth; }) * 1.3
    this.yScale.domain([0, max]);

    const annualIncomeMax = d3.max(data, function(d) { return Math.abs(d.netDistributionReal); }) * 3
    
    this.yAnnualIncomeScale.domain([0, annualIncomeMax]);

    // Draw our primary line for wealth accumulation
    var wealth = d3.line()
    .x(d => this.xScale(d.age))
    .y(d => this.yScale(d.totalWealth))
    .curve(d3.curveBundle.beta(1))


    // var svg = d3.select(this.chartRef).append("svg")
    //   .attr("width", width)
    //   .attr("height", height)
    //   .append("g")
      // .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

    this.renderAxisLine(svg)
    this.renderAnnualIncomeDistribution(svg)
    this.renderTooltip(svg, margin)

    // console.warn('tix', d3.ticks(0,90, 15))

    svg.append('line')
      .attr('class', 'axis_line_above_number')
      .attr('x1', 0)
      .attr('x2', this.width)
      .attr('y1', this.height + margin.top)
      .attr('y2', this.height + margin.top)

    // Add the x Axis
    svg.append("g")
    .attr("transform", "translate(0," + this.height + ")")
    .call(d3.axisBottom(this.xScale).tickSize(0).tickPadding(9));
    // y-axis
    svg.append("g")
    .attr("transform", "translate(0, 0)")
    .call(d3.axisLeft(this.yScale).tickArguments([8]).tickSize(0).tickPadding(8).tickFormat(d3.format('.3s')));


    // y-axis annual income distribution
    svg.append("g")
    .attr("transform", `translate(${this.width}, 0)`)
    .call(d3.axisRight(this.yAnnualIncomeScale).tickArguments([5]).tickSize(0).tickPadding(8).tickFormat(d3.format('1.0s')));
    // // text label for the x axis
    // svg.append("text")             
    //   .attr("transform",
    //         "translate(" + (this.width/2) + " ," + 
    //                       (this.height + 0 + 30) + ")")
    //   .style("text-anchor", "middle")
    //   .text("Age");


    // Add the valueline path. - before retirement
    svg.append("path")
    .data([data.filter(d => d.age <= this.props.retirementAge)])
    .attr("class", "line line--pre_retirement")
    .attr("d", wealth);
    // after retirement
    svg.append("path")
      .data([data.filter(d => d.age >= this.props.retirementAge)])
      .attr("class", "line line--post_retirement")
      .attr("d", wealth);


    this.renderRetirementLabel(svg)

    // svg.append("rect")
    //   .attr("transform", "translate(0,0)")
    //   .attr("class", "overlay")
    //   .attr("width", 130)
    //   .attr("height", 70)
    //   .on("mousemove", this.onMouseEnter);

      // .on("mouseover", function() { focus.style("display", null); })
      // .on("mouseout", function() { focus.style("display", "none"); })

    svg.selectAll("circle")
      .data(data)
      
      .enter()
      .filter(d => {
        return d.age === parseInt(this.props.retirementAge)
      })
      .append('circle')
      
      .attr('r', 6)
      .attr('cx', d => this.xScale(d.age))
      .attr('cy', d => this.yScale(d.totalWealth))
      .attr('class', 'RetirementMarker')

    console.error(data)
    // event for tooltip
    // svg.append('g').attr('class', 'event-container')
    //   .selectAll("rect")
    //   .data(data)
    //   .enter()
    //   .append('rect')
    //   .attr('width', (d, i) => {
    //     console.log(d, i)
    //     return this.width / this.props.chartData.length
    //   })
    //   .attr('height', this.height)
    //   .attr('x', d => this.xScale(d.age) - (this.width / this.props.chartData.length))
    //   .attr('y', d => 0)
    //   .attr('class', 'tmp')
    //   .on('mouseenter', this.onMouseEnter)
    // TOOLTIp
    // this.tooltipRef = svg.append("rect")
    //   .attr("transform", d => `translate(0, 0)`)
    //   .attr("class", "overlay")
    //   .attr('fill', 'red')
    //   .attr("width", 130)
    //   .attr("height", 70)
  }

  onMouseEnter(dataRow) {
    console.log('onMouseEnter', dataRow)

    this.tooltipRef.attr('transform', `translate(${this.xScale(dataRow.age)},${this.yScale(dataRow.totalWealth)})`)

  }

  componentDidMount() {
    console.warn(1)


    // <div className="RetirementChart__label RetirementChart__label--wealth">Wealth</div>
    // <div className="RetirementChart__label RetirementChart__label--income">Annual Income Distribution</div>
    // <div className="RetirementChart__label RetirementChart__label--age">Age</div>

    // d3.select(this.chartRef)
    //   .selectAll('p')
    //   .data(data)
    //   .enter()
    //   .append('p')
    //   .text((d) => d.age)
  }

  render() {

    // const tooltip = (
    //   <div className="ChartTooltip" ref={r => this.tooltipRef = r}>tooltip</div>
    // )

    return (

      <div className="RetirementChart">

        <div className="Chart" ref={r => this.chartRef = r}></div>
        <p className="RetirementChart__label RetirementChart__label--wealth">Total Wealth (in nominal terms)</p>
        <p className="RetirementChart__label RetirementChart__label--age">Age</p>
        <p className="RetirementChart__label RetirementChart__label--income">Net Distribution (in real terms)</p>
      
      </div>
    )
  }
}

export default RetirementChart


// WEBPACK FOOTER //
// ./sections/retirement-chart/retirement-chart.js